import styled from 'styled-components'
import colors from '../../../assets/colors'

export const Container = styled.div`
  border-radius: 40px;
  padding: 40px;
  background-color: ${colors.white};
  margin-bottom: 60px;
`
